import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { PageServicesModule } from './page-services/page-services.module';
import { SharedModule } from './shared.module';

import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { NotFoundComponent } from './components/not-found/not-found.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ServiceService } from './page-services/services/service.service';
import { ApiService } from './services/api.service';
import { LoadingService } from './services/loading.service';
import { NotificationsService } from './services/notifications.service';
import { LoadingComponent } from './directives/loading.component';
import { NotificationsComponent } from './directives/notifications.component';
import {SignModule} from './sign/sign.module';
import {AuthGuard} from './services/auth.guard';
import {NoauthGuard} from './services/noauth.guard';
import {AuthenticationService} from './services/authentication.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    NavbarComponent,
    FooterComponent,
    LoadingComponent,
    NotificationsComponent
  ],
  exports: [LoadingComponent, NotificationsComponent],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    PageServicesModule,
    SharedModule,
    NgbModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ReactiveFormsModule,
    SignModule,
    AppRoutingModule
  ],
  providers: [
    ServiceService,
    ApiService,
    LoadingService,
    NotificationsService,
    AuthGuard,
    NoauthGuard,
    AuthenticationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
